import { render, staticRenderFns } from "./ItemsDetails.vue?vue&type=template&id=0b7d7d6c&scoped=true&"
import script from "./ItemsDetails.vue?vue&type=script&lang=js&"
export * from "./ItemsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ItemsDetails.vue?vue&type=style&index=0&id=0b7d7d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d7d6c",
  null
  
)

export default component.exports